<template lang="pug">
EditableControl.date(:id="id" :displayValue="displayValue" :bus="bus" :editing="editing" :editByDefault="editByDefault" :errors="errors" :navigationRoute="navigationRoute")
  datepicker.grow(v-if="showDatePicker" :id="id + 'picker'" type='date' v-model='value_' format="dd MMMM yyyy" placeholder='dd/mm/yyyy' monday-first bootstrap-styling :required="required" :typeable="true" @input="onUpdate")
  .date-remove(v-if="(!required || titles.close) && this.value_ && this.value_ !== this.$Constants.SaveTrees.Date.Ongoing" @click="removeDate")
    FontAwesomeIcon.icon(:icon='$icons.close' :title="closeTitle")
</template>

<script>
import { mixins } from "../EditableControl/mixins";
import { Events } from "../Block/index";
import "./scss";
import { CalendarDate } from "@gemma/dates";

export default {
  name: "Date",
  mixins: [mixins("value")],
  props: {
    required: {
      type: Boolean,
      default: true,
    },
    titles: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Date, CalendarDate],
      required: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
  },
  data() {
    return {
      showDatePicker: true,
    };
  },
  computed: {
    closeTitle() {
      return this.titles.close || "Remove date";
    },
    selectDateTitle() {
      return this.titles.selectDate || "Select from date picker";
    },
    valueAsCalendarDate() {
      if (!this.value || this.value === this.$Constants.SaveTrees.Date.Ongoing) {
        return this.value;
      } else {
        return new CalendarDate(this.value);
      }
    },
    value_AsCalendarDate() {
      if (!this.value_ || this.value_ === this.$Constants.SaveTrees.Date.Ongoing) {
        return this.value_;
      } else {
        return new CalendarDate(this.value_);
      }
    },
  },
  created() {
    this.bus.$on(Events.Active, this.onActive);
    this.bus.$on(Events.Cancel, this.onCancel);
  },
  destroyed() {
    this.bus.$off(Events.Active, this.onActive);
    this.bus.$off(Events.Cancel, this.onCancel);
  },
  methods: {
    cancel() {
      this.$emit(Events.Cancel, this);
    },
    onUpdate(value) {
      if (value !== this.value && !(value == null && this.value === this.$Constants.SaveTrees.Date.Ongoing)) {
        this.bus.$emit(Events.Change, { id: this.id, value, vm: this });
        this.$emit(Events.Change, { id: this.id, value, vm: this });
      }
    },
    removeDate() {
      if (this.value_ !== this.$Constants.SaveTrees.Date.Ongoing) {
        this.value_ = this.$Constants.SaveTrees.Date.Ongoing;
        this.bus.$emit(Events.Change, { id: this.id, value: undefined, vm: this });
        this.$emit(Events.Change, { id: this.id, value: undefined, vm: this });
      }
    },
  },
};
</script>
